/**
 * MCP Configuration
 * 
 * This file contains configuration for Model Context Protocol (MCP) services
 * like Vapi, Supabase, and other integrations.
 */

// Get environment variables
const VAPI_API_KEY = import.meta.env.VITE_VAPI_API_KEY || process.env.VITE_VAPI_API_KEY;
const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL || process.env.VITE_SUPABASE_URL;
const SUPABASE_ANON_KEY = import.meta.env.VITE_SUPABASE_ANON_KEY || process.env.VITE_SUPABASE_ANON_KEY;

// MCP Configuration
export const mcpConfig = {
  // Vapi configuration
  voice: {
    vapi: {
      apiKey: VAPI_API_KEY,
      mcpUrl: 'https://mcp.vapi.ai/sse',
      defaultVoice: 'sarah',
      defaultProvider: '11labs'
    }
  },
  
  // Supabase configuration
  database: {
    supabase: {
      url: SUPABASE_URL,
      anonKey: SUPABASE_ANON_KEY
    }
  },
  
  // Default assistant configuration
  assistant: {
    defaultModel: 'gpt-4o',
    defaultProvider: 'openai',
    defaultTranscriber: {
      provider: 'deepgram',
      model: 'nova-3'
    }
  }
};

// Export default configuration
export default mcpConfig;
